import axios from 'axios';
import { appendTokenToUrl } from '../components/context/Recaptcha';

const { additionalHeaders, loginRootUrl } = window.appAirDrop.config;

export async function verifyMobileCode(verifyData: any, recaptchaToken?: string) {
  const path = `${loginRootUrl}/login/verifyMobileCode`;
  const response = await axios.post(
    appendTokenToUrl(path, recaptchaToken),
    new URLSearchParams(verifyData).toString(),
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      withCredentials: true,
    },
  );

  return response;
}

export async function verifyMobileCodeForForgot(verifyData: any, recaptchaToken?: string) {
  const path = `${loginRootUrl}/login/verifyMobileCodeForForgot`;
  const response = await axios.post(
    appendTokenToUrl(path, recaptchaToken),
    new URLSearchParams(verifyData).toString(),
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      withCredentials: true,
    },
  );

  return response;
}
